import { useTranslation } from "react-i18next";

import { apiBaseUrl } from "@/services/apiClient";

export function GoogleSsoButton({
  label,
  intent,
  returnTo,
}: {
  label?: string;
  /**
   * Carried through to the SSO controller so first-time accountant signups
   * land on the accountant onboarding flow. Login pages pass nothing (or
   * 'business'); accountant register passes 'accountant'.
   */
  intent?: "business" | "accountant";
  /**
   * Portal path to land on after the SSO bounce completes. The backend
   * stores it in an httpOnly cookie during initiate and embeds it as a
   * query param on the portal callback URL. Only specific paths are
   * honored (see backend `sanitizeReturnTo`) — currently
   * `/accept-invitation` so an invite token can survive the round-trip.
   */
  returnTo?: string;
}): JSX.Element {
  const { t } = useTranslation();
  const text = label ?? t("auth.sso.continueWithGoogle", "Continuar con Google");
  return (
    <button
      type="button"
      className="fx-auth-btn fx-auth-btn-ghost"
      onClick={() => {
        const params = new URLSearchParams();
        if (intent) params.set("intent", intent);
        if (returnTo) params.set("returnTo", returnTo);
        const query = params.toString() ? `?${params.toString()}` : "";
        window.location.href = `${apiBaseUrl}/auth/sso/google${query}`;
      }}
    >
      <GoogleGlyph />
      {text}
    </button>
  );
}

function GoogleGlyph(): JSX.Element {
  return (
    <svg
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fill="#4285F4"
        d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.614z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
      />
    </svg>
  );
}
